import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
@Injectable({
  providedIn: 'root'
})
export class PopupService {

  constructor() { }

  success(tittle, message) {
    Swal.fire({
      title: tittle,
      text: message,
      icon: 'success',
      timerProgressBar: true,
      timer: 2500,
      confirmButtonText: 'Ok'
    });
  }

  successWithConfirm(tittle, message) {
    Swal.fire({
      title: tittle,
      text: message,
      icon: 'success',
      confirmButtonText: 'Ok'
    });
  }

  error(tittle, message, timer?) {
    Swal.fire({
      title: tittle,
      text: message,
      icon: 'error',
      timerProgressBar: true,
      timer: timer || 2500,
      confirmButtonText: 'Ok'
    });
  }

  errorWithConfirm(tittle, message) {
    Swal.fire({
      title: tittle,
      text: message,
      icon: 'error',
      confirmButtonText: 'Ok'
    });
  }

  warning(tittle, message) {
    Swal.fire({
      title: tittle,
      text: message,
      icon: 'warning',
      timerProgressBar: true,
      timer: 2500,
      confirmButtonText: 'Ok'
    });
  }

  warningWithConfirm(tittle, message) {
    Swal.fire({
      title: tittle,
      text: message,
      icon: 'warning',
      confirmButtonText: 'OK'
    });
  }

  successWebinar(tittle, message) {
    Swal.fire({
      title: tittle,
      html: message,
      icon: 'success',
      confirmButtonText: 'Ok'
    });
  }
  appointmentInformation(title, msgIcon, message) {
    Swal.fire({
      title: title,
      html: message,
      icon: msgIcon,
      confirmButtonText: 'Ok'
    });
  }

  naInfo(tittle, message) {
    Swal.fire({
      title: tittle,
      text: 'This feature is restricted only to Miles CPA students.',
      icon: 'warning',
      timerProgressBar: true,
      timer: 2500,
      confirmButtonText: 'Ok'
    });
  }

  newMenuPopup(tittle, message) {
    Swal.fire({
      title: tittle,
      text: 'This Feature will be coming soon!',
      icon: 'info',
      timerProgressBar: true,
      timer: 2500,
      confirmButtonText: 'Ok'
    });
  }

  feedbackPopup(tittle, message) {
    return Swal.fire({
      title: tittle,
      html: message,
      icon: 'success',
      showConfirmButton: true,
      confirmButtonText: 'Continue',
      showCancelButton: true,
      cancelButtonText: 'Exit'
    })
  }  

  comingSoonPop(tittle, message) {
    Swal.fire({
      title: tittle,
      text: 'Coming Soon!',
      icon: 'info',
      timerProgressBar: true,
      timer: 2500,
      confirmButtonText: 'Ok'
    });
  }

  confirmationPopup(title: string, message: string) {
    return Swal.fire({
      title: title,
      text: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Proceed',
      cancelButtonText: 'Cancel',
    });
  }

  srSpocContactPopup(spocName: string, spocEmail: string, spocPhone: string) {
  const htmlContent = `
    <div style="
      text-align: left;
      padding: 10px;
      font-family: 'OpenSansRegular', sans-serif;
      color: #231F20;
      line-height: 1.5;
    ">
      <p style="margin-bottom: 12px; font-size: 15px; font-family: 'OpenSansRegular', sans-serif;">
        The contact details for your SR SPOC
        <strong style="color: #06345B; font-family: 'OpenSansSemiBold', sans-serif;">${spocName}</strong>
        have been updated.
      </p>

      <div style="
        background: #EBF4FF;
        border: 1px solid #B6B9BD;
        border-radius: 10px;
        padding: 12px;
        margin-bottom: 12px;
      ">
        <div style="margin: 6px 0; font-size: 15px; display: flex; align-items: center; justify-content: space-between;">
          <div>
            <strong style="color: #06345B; font-family: 'OpenSansSemiBold', sans-serif;">📧 Email:</strong>
            <span style="color: #0348AA; font-family: 'OpenSansRegular', sans-serif;">${spocEmail}</span>
          </div>
          <div
            id="copyEmailBtn"
            style="
              cursor: pointer;
              margin-left: 8px;
              display: flex;
              align-items: center;
              transition: opacity 0.3s;
            "
            title="Click to copy email"
          >
            <svg id="emailCopyIcon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z" fill="#0348AA"/>
            </svg>
            <span id="emailCopyText" style="margin-left: 4px; font-size: 11px; color: #0348AA; font-family: 'OpenSansSemiBold', sans-serif;"></span>
          </div>
        </div>
        <div style="margin: 6px 0; font-size: 15px; display: flex; align-items: center; justify-content: space-between;">
          <div>
            <strong style="color: #06345B; font-family: 'OpenSansSemiBold', sans-serif;">📞 Phone:</strong>
            <span style="color: #0348AA; font-family: 'OpenSansRegular', sans-serif;">${spocPhone}</span>
          </div>
          <div
            id="copyPhoneBtn"
            style="
              cursor: pointer;
              margin-left: 8px;
              display: flex;
              align-items: center;
              transition: opacity 0.3s;
            "
            title="Click to copy phone"
          >
            <svg id="phoneCopyIcon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z" fill="#0348AA"/>
            </svg>
            <span id="phoneCopyText" style="margin-left: 4px; font-size: 11px; color: #0348AA; font-family: 'OpenSansSemiBold', sans-serif;"></span>
          </div>
        </div>
      </div>

      <p style="margin-bottom: 8px; font-size: 13px; font-family: 'OpenSansRegular', sans-serif; color: #231F20;">
        Please make note of these changes for future reference.
      </p>
      <p style="margin: 0; font-size: 13px; font-family: 'OpenSansRegular', sans-serif; color: #231F20;">
        You can also view the updated details anytime on the LMS under:
        <strong style="color: #06345B; font-family: 'OpenSansSemiBold', sans-serif;">Resources > Contact</strong>.
      </p>
    </div>
  `;

  return Swal.fire({
    title: '<span style="color: #06345B; font-family: \'OpenSansSemiBold\', sans-serif; font-size: 20px;">Updated Contact Details for Your SR SPOC</span>',
    html: htmlContent,
    icon: 'info',
    confirmButtonText: 'Close',
    confirmButtonColor: '#0348AA',
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    showCloseButton: false,
    customClass: {
      // popup: 'sr-spoc-contact-popup',
      // icon: 'sr-spoc-icon-small'
    },
    onOpen: () => {
      // Add click event listener for email copy icon
      const copyEmailBtn = document.getElementById('copyEmailBtn');
      const emailCopyIcon = document.getElementById('emailCopyIcon');
      const emailCopyText = document.getElementById('emailCopyText');

      if (copyEmailBtn && emailCopyIcon && emailCopyText) {
        copyEmailBtn.addEventListener('click', () => {
          navigator.clipboard.writeText(spocEmail).then(() => {
            // Change icon color to green and show "Copied!" text
            emailCopyIcon.querySelector('path').setAttribute('fill', '#00c851');
            emailCopyText.textContent = 'Copied!';
            emailCopyText.style.color = '#00c851';

            // Reset after 2 seconds
            setTimeout(() => {
              emailCopyIcon.querySelector('path').setAttribute('fill', '#0348AA');
              emailCopyText.textContent = '';
            }, 2000);
          }).catch(err => {
            console.error('Failed to copy email: ', err);
          });
        });

        // Add hover effect
        copyEmailBtn.addEventListener('mouseenter', () => {
          emailCopyIcon.querySelector('path').setAttribute('fill', '#06345B');
        });
        copyEmailBtn.addEventListener('mouseleave', () => {
          if (emailCopyText.textContent !== 'Copied!') {
            emailCopyIcon.querySelector('path').setAttribute('fill', '#0348AA');
          }
        });
      }

      // Add click event listener for phone copy icon
      const copyPhoneBtn = document.getElementById('copyPhoneBtn');
      const phoneCopyIcon = document.getElementById('phoneCopyIcon');
      const phoneCopyText = document.getElementById('phoneCopyText');

      if (copyPhoneBtn && phoneCopyIcon && phoneCopyText) {
        copyPhoneBtn.addEventListener('click', () => {
          navigator.clipboard.writeText(spocPhone).then(() => {
            // Change icon color to green and show "Copied!" text
            phoneCopyIcon.querySelector('path').setAttribute('fill', '#00c851');
            phoneCopyText.textContent = 'Copied!';
            phoneCopyText.style.color = '#00c851';

            // Reset after 2 seconds
            setTimeout(() => {
              phoneCopyIcon.querySelector('path').setAttribute('fill', '#0348AA');
              phoneCopyText.textContent = '';
            }, 2000);
          }).catch(err => {
            console.error('Failed to copy phone: ', err);
          });
        });

        // Add hover effect
        copyPhoneBtn.addEventListener('mouseenter', () => {
          phoneCopyIcon.querySelector('path').setAttribute('fill', '#06345B');
        });
        copyPhoneBtn.addEventListener('mouseleave', () => {
          if (phoneCopyText.textContent !== 'Copied!') {
            phoneCopyIcon.querySelector('path').setAttribute('fill', '#0348AA');
          }
        });
      }
    }
  });
}
}
